<template>
  <div class="previews">
    <v-container>
      <v-layout row class="search-header">
        <v-flex xs12 pa-4 pr-5>
          <h1 class="text-xs-center">{{ componentType }}</h1>
        </v-flex>
      </v-layout>
      <v-layout row v-if="componentType === 'Buttons'">
        <v-flex xs12>
          <div class="type-card">
            <p class="type-explanation">Sokal offers custom CTA buttons in addition to secondary buttons to help guide users to submit specific leads linked to each vehicle. The buttons below are only some of the options available and can be omitted in place of simpler text buttons. If you need one edited with different fonts or colors, or if you'd like something else entirely, our creative team is here for your dealership's needs.</p>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container grid-list fill-height :class="componentType === 'Pricing' ? '' : 'fluid'">
      <v-layout row wrap px-4>
        <v-flex
          :class="['xs12', 'sm12', 'md6', componentType === 'Buttons' ? 'lg3' : 'lg6']"
          v-for="component in currentComponentCollection"
          :key="component.id"
        >
          <SRPComponentPreview
            :componentType="componentType"
            :component="component"
          />
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapState } from "vuex";
import SRPComponentPreview from "./SRPComponentPreview";

export default {
  name: "SRPComponentSelector",
  props: {
    componentType: {
      type: String,
      required: true,
      validator: function (value) {
        return ["Search Results", "Pricing", "Buttons"].includes(value);
      },
    },
    selectedBrand: {
      type: String
    }
  },
  data() {
    return {
      selectedType: "",
    };
  },
  computed: {
    ...mapState([
      "srpComponents",
      "pricingComponents",
      "buttonComponents",
      "chosenComponents",
    ]),
    isLockedPricingSelected() {
      return !!this.chosenComponents.find((c) => c.title === "Locked Pricing");
    },
    isGridBasedSRPSelected() {
      return !!this.chosenComponents.find(
        (c) => c.title === "Grid based Search Results"
      );
    },
    currentComponentCollection() {
      if (this.componentType === "Buttons") {
        if (this.isLockedPricingSelected) {
          if (this.isGridBasedSRPSelected) {
            return this.componentMap.Buttons.lockedPricing.filter((c) =>
              c.srp_types.includes("grid")
            );
          }
          return this.componentMap.Buttons.lockedPricing.filter((c) =>
            c.srp_types.includes("row")
          );
        }
        if (this.isGridBasedSRPSelected) {
          return this.componentMap.Buttons.unlockedPricing.filter((c) =>
            c.srp_types.includes("grid")
          );
        }
        return this.componentMap.Buttons.unlockedPricing.filter((c) =>
          c.srp_types.includes("row")
        );
      }
      return this.componentMap[this.componentType];
    },
    componentMap() {
      return {
        "Search Results": this.filterBrand(this.srpComponents),
        Pricing: this.pricingComponents,
        Buttons: this.buttonComponents,
      };
    },
  },
  methods: {
    filterBrand (comps) {
      if (this.selectedBrand.toLowerCase() === "mazda") {
        return comps.filter((c) =>
          c.exclusive.includes("Mazda")
        );
      } else {
        return comps.filter((c) =>
          c.exclusive.length === 0
        );
      }
    }
  },
  components: {
    SRPComponentPreview,
  },
};
</script>

<style>
.previews .search-header h1 {
  color: #006aff;
  font-size: 3em;
  font-weight: 500;
}
.previews p.type-explanation {
  font-size: 16px;
  margin-bottom: 5px;
}
.previews .type-card {
  background: #EAF7FC;
  padding: 30px;
}
</style>
